import { useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IOrganisation, IOrganisationSettings } from '~/Models/DTO/Organisation.model';
import { ItemCreation } from '~/ModularComponents';
import { useOrganisationSettings } from '.';
import { OrganisationSettingsGeneralSection } from './OrganisationSettingsSection';

export const OrganisationSettings = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const {
    onSave,
    initialValues,
    validate,
    error,
    isLoading,
    validationSchema,
    currentOrganisation,
  } = useOrganisationSettings();

  return (
    <ItemCreation<IOrganisation & IOrganisationSettings>
      modalTitle={`${t('app.settings')} ${currentOrganisation?.name}`}
      onSave={onSave}
      initialValues={initialValues}
      validate={validate}
      networkErrors={error}
      isLoading={isLoading}
      validationSchema={validationSchema}
      hideBackButton={!isMobile}
      skipConfirmationModal
    >
      <OrganisationSettingsGeneralSection />
    </ItemCreation>
  );
};
